import { ConstantTempoTiming } from '@ezchops/timing';
import { chain, omit, pick } from 'lodash';
import range from 'lodash/range';
import { Evaluator } from './Evaluator';
export class MetronomeEvaluator extends Evaluator {
    _ticks;
    _evaluation;
    constructor(practice, options = {}) {
        const timingSignature = { ...practice.signature, tickNote: practice.tickNote };
        const timing = new ConstantTempoTiming(timingSignature, practice.tempo, 0, 0, undefined);
        super(timing, practice, options);
        this._ticks = [];
        this._evaluation = [];
    }
    get evaluation() {
        return this._evaluation;
    }
    get ticks() {
        return this._ticks;
    }
    reset = () => {
        super._reset();
        this._ticks = [];
        this._evaluation = [];
    };
    evaluate = (from, to) => {
        this.extendTo(Math.max(from, to ?? 0));
        return this.evaluation.slice(from, to);
    };
    push = (...hits) => {
        super._push(...hits);
        this.mapToTicks(hits);
    };
    mapToTicks = (hits) => {
        const snapped = hits.map(this.snapHit);
        chain(snapped)
            .groupBy('tick')
            .forEach((snapped, ts) => {
            const tick = parseInt(ts);
            this.extendTo(tick);
            const mappedTick = this._ticks[tick];
            mappedTick.hits.push(...snapped);
            const evaluation = this._evaluation[tick];
            const evaluated = snapped.map(s => pick(s, ['hit', 'note', 'lag']));
            evaluation.evaluated.push(...evaluated);
        })
            .value();
    };
    evaluateTick = (tick) => {
        this.extendTo(tick);
    };
    extendTo = (tick) => {
        if (this._ticks.length <= tick) {
            const tickEextension = range(this._ticks.length, tick + 1).map(tick => ({
                ...this.timing.tickPosition(tick),
                hits: []
            }));
            this._ticks.push(...tickEextension);
            const evaluationExtension = tickEextension.map(tick => ({
                ...omit(tick, 'hits'),
                evaluated: []
            }));
            this._evaluation.push(...evaluationExtension);
        }
    };
    label = ({ expected, hit, lag }) => {
        if (hit == null) {
            throw new Error('No hit');
        }
        if (lag == null) {
            throw new Error('No lag');
        }
        const threshold = 1 / this.options.resolution;
        if (lag < -threshold) {
            return 'early';
        }
        if (lag > threshold) {
            return 'late';
        }
        return 'accurate';
    };
    score = ({ expected, hit, lag }) => {
        if (hit == null) {
            throw new Error('No hit nor expected');
        }
        if (lag == null) {
            throw new Error('No lag');
        }
        const threshold = 1 / (this.timing.tickNote * 2);
        if (lag < -threshold) {
            return 0;
        }
        if (lag > threshold) {
            return 0;
        }
        return Math.exp(-0.5 * (lag / this.sigma) ** 2);
        //return 1 - (Math.abs(lag) / threshold)
    };
    maxScore = ({ expected, hit, lag }) => {
        if (hit == null) {
            throw new Error('No hit');
        }
        return 1;
    };
}
//# sourceMappingURL=MetronomeEvaluator.js.map